import React from 'react';

class DoyoucontinueChengyu extends React.Component {

	render() {
		const precision = this.props.shownPrecision;

		return (
		<div className="container">
			<div className="alert alert-primary">
				<h4>You{"'"}ve completed the test.</h4>
				<p>
					You can see your results now, or keep going to sharpen them.
					{precision !== null &&
						<span> Your estimate is currently within <strong>{precision} chengyu</strong>, and every further question narrows that.</span>
					}
				</p>
				<div>
	              <button className="btn btn-secondary btn-doyoucontinue" type="button" onClick={(e) => this.props.onContinueOrResults(e, false)} >
	                See my results
	              </button>
	              <button className="btn btn-primary btn-doyoucontinue" type="button" onClick={(e) => this.props.onContinueOrResults(e, true)} >
	                Continue the test
	              </button>
	            </div>
			</div>
		</div>
		);
	}
}


export default DoyoucontinueChengyu